var React = require('react');

function Listening (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .forms {\n        fill:#e5fd57;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("ellipse",{"className":"forms","cx":"193.99","cy":"245.84","rx":"267.43","ry":"161.49","transform":"translate(-115.91 290.92) rotate(-60)","key":1})]);
}

Listening.defaultProps = {"id":"listening","data-name":"listening","viewBox":"0 0 387.98 491.68"};

module.exports = Listening;

Listening.default = Listening;
